export default "__VITE_ASSET__C$84YI28__"